module.exports = __webpack_public_path__ + "01f43047/img/comments-icon.fdec7fdb.svg";